// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2dSuk","emails":"CreateEditClinics_emails__m-HlQ","emailTagLabel":"CreateEditClinics_emailTagLabel__no3to"};